import { INSTANCE_SPECIAL_CHAT_TYPES } from "services/types";

const INITIAL_STATE = {
  instanceSpecialChatUpdate: [],
  instanceSpecialChatUpdateLoading: false,
};

export default function instanceSpecialChatReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    // instance message pagination
    case INSTANCE_SPECIAL_CHAT_TYPES.INSTANCE_SPECIAL_MESSAGE_CHAT_INIT:
      return {
        ...state,
        instanceSpecialChatUpdate: [],
        instanceSpecialChatUpdateLoading: true,
      };
    case INSTANCE_SPECIAL_CHAT_TYPES.INSTANCE_SPECIAL_MESSAGE_CHAT_SUCCESS:
      return {
        instanceSpecialChatUpdate: action.payload,
        instanceSpecialChatUpdateLoading: false,
      };
    case INSTANCE_SPECIAL_CHAT_TYPES.INSTANCE_SPECIAL_MESSAGE_CHAT_FINISH:
      return {
        ...state,
        instanceSpecialChatUpdate: [],
        instanceSpecialChatUpdateLoading: false,
      };

    default:
      return { ...state };
  }
}
